var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.338,435.827l-31.204-236.43c-5.141-31.826-32.612-55.217-64.855-55.217h-57.173 c-29.617,0-33.833-14.237-33.833-30.883c0-17.046,4.86-23.169,16.658-24.804c20.899-2.569,37.101-20.361,37.101-41.958v-4.23 C350.033,18.939,331.093,0,307.729,0H204.272c-23.365,0-42.304,18.939-42.304,42.304v4.23c0,21.597,16.201,39.388,37.1,41.958 c11.789,1.635,16.66,7.758,16.66,24.804c0,16.646-4.217,30.883-33.834,30.883h-57.172c-32.244,0-59.714,23.391-64.856,55.217 l-31.203,236.43c-3.071,19.01,2.355,38.411,14.833,53.066C55.973,503.557,74.267,512,93.513,512h324.974 c19.245,0,37.531-8.443,50.018-23.108C480.984,474.238,486.408,454.837,483.338,435.827z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantity);
export default __webpack_public_path__ + "static/media/quantity.71035e71fd9f55b9c42f8175ee72cbcc.svg";
export { ForwardRef as ReactComponent };